import * as React from "react";
import classnames from "classnames";
import ButtonLoader from "../../ButtonLoader/ButtonLoader/ButtonLoader.js";
/* empty css            */
const Button = ({
  children,
  className,
  type = "button",
  variant,
  size,
  loading,
  loadingLabel,
  ...props
}) => {
  const classes = React.useMemo(
    () => classnames(
      "btn",
      `btn--${variant}`,
      { [`btn--${size}`]: variant !== "ghost" && size && size !== "medium" },
      className
    ),
    [className, variant, size]
  );
  const a11y = React.useMemo(() => {
    if (!loading) {
      return {};
    }
    return {
      role: "status",
      "aria-live": "polite",
      ...loadingLabel && { "aria-label": loadingLabel }
    };
  }, [loading, loadingLabel]);
  return /* @__PURE__ */ React.createElement("button", { type, className: classes, ...props, ...a11y }, loading && /* @__PURE__ */ React.createElement(ButtonLoader, null), /* @__PURE__ */ React.createElement("span", null, children));
};
export {
  Button as default
};
//# sourceMappingURL=Button.js.map
